import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Button, Tooltip } from "@fluentui/react-components";
import { InfoRegular } from "@fluentui/react-icons";

export function InfoButton({ info, ...buttonProps }) {
  const buttonRef = useRef(null);
  const [supportsHover, setSupportsHover] = useState(true);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
    setSupportsHover(mediaQuery.matches);

    const handleChange = event => {
      setSupportsHover(event.matches);
    };

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }

    if (mediaQuery.addListener) {
      mediaQuery.addListener(handleChange);
      return () => mediaQuery.removeListener(handleChange);
    }

    return undefined;
  }, []);

  useEffect(() => {
    if (!supportsHover && visible) {
      const handleClickOutside = event => {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
          setVisible(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("touchstart", handleClickOutside);
      };
    }

    return undefined;
  }, [supportsHover, visible]);

  const handleClick = event => {
    event.stopPropagation();
    if (!supportsHover) {
      setVisible(previous => !previous);
    }
    buttonProps.onClick?.(event);
  };

  const handleVisibleChange = (_, data) => {
    if (!supportsHover) {
      setVisible(data.visible);
    }
  };

  const tooltipProps = {
    content: info,
    relationship: "label",
    withArrow: true
  };

  if (!supportsHover) {
    tooltipProps.visible = visible;
    tooltipProps.onVisibleChange = handleVisibleChange;
  }

  return (
    <Tooltip {...tooltipProps}>
      <Button
        appearance="transparent"
        ref={buttonRef}
        icon={<InfoRegular />}
        onClick={handleClick}
        {...buttonProps}
      />
    </Tooltip>
  );
}

InfoButton.propTypes = {
  info: PropTypes.string.isRequired
};

export default InfoButton;


